import { render } from "./Articoli.vue?vue&type=template&id=946defac"
import script from "./Articoli.vue?vue&type=script&lang=js"
export * from "./Articoli.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\SHIRE\\nic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__